import React, { useEffect, useState } from 'react';
import { useLocation, useNavigation } from '@remix-run/react';

const TRANSITION_DELAY_MS = 120;

export function RouteProgress() {
  const navigation = useNavigation();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (navigation.state === 'idle') {
      const timeout = window.setTimeout(() => {
        setProgress(100);
        const hideTimeout = window.setTimeout(() => {
          setIsVisible(false);
          setProgress(0);
        }, 250);
        return () => window.clearTimeout(hideTimeout);
      }, TRANSITION_DELAY_MS);
      return () => window.clearTimeout(timeout);
    }

    setIsVisible(true);
    setProgress((prev) => (prev < 40 ? 40 : prev));

    const interval = window.setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 10;
      });
    }, 200);

    return () => window.clearInterval(interval);
  }, [navigation.state, location.key]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5">
      <div
        className="h-full w-full origin-left bg-gradient-to-r from-primary to-accent"
        style={{
          transform: `scaleX(${Math.min(progress, 100) / 100})`,
          transformOrigin: 'left',
          transition: 'transform 200ms ease-out',
        }}
      />
    </div>
  );
}
